import { FC } from 'react';
import { useIntl } from 'react-intl'

interface FormToggleProps {
    formik: any;
    disabled: boolean;
    name: string;
    activeText: string;
    inactiveText: string;
}

const FormToggle: FC<FormToggleProps> = ({ formik, disabled, name, activeText, inactiveText }) => {
    const isActive = formik.values[name];
    const intl = useIntl()

    return (
        <div className='col-12 my-3 px-1'>
            <button
                type="button"
                disabled={disabled}
                className={`btn ${isActive ? 'btn-success' : 'btn-danger'} w-100 h-50px px-0`}
                onClick={() => formik.setValues({ ...formik.values, [name]: !isActive })}
            >
                {isActive ? intl.formatMessage({ id: activeText }) : intl.formatMessage({ id: inactiveText })}
            </button>
        </div>
    );
};

export default FormToggle;
